import { View } from '@/components/Theme/View';
import { ThemeView } from '@/components/Theme/ThemeView';
import { useLayout } from '@/hooks/useContentLayout';
import { useResponsiveGrid } from '@/hooks/useResponsiveGrid';
import isEqual from 'lodash/isEqual';
import React, { forwardRef, memo, useEffect } from 'react';

export const ResponsiveRow = memo(forwardRef((props, ref) => {

    const {
        xs = null,
        sm = null, 
        md = null,
        lg = null,
        xl = null,

        style = {},
        children = null,
        onLayout = null,
        light = 'transparent',
        dark = 'transparent',
        ...rest
    } = props || {};
    
    const content = useLayout();
    
    useEffect(() => {
        if (content?.layout && onLayout)
            onLayout(content?.layout);
    }, [content?.layout]);

    const { orderedChildren } = useResponsiveGrid({...props, window: content?.layout});

    return (
        <ThemeView light={light} dark={dark} {...rest} onLayout={content.onLayout} style={{flexWrap: 'wrap', flexDirection: 'row', ...style}} ref={ref}>
            {(content?.width != 0 || content.height != 0) && React.Children.map(orderedChildren, (child, index) => {
                const {key, style, children, ...rest} = child.props;

                return (
                    <View key={`responsive-row-${key}`} style={style} {...rest}>
                        {children}
                    </View>
                )

            })}
        </ThemeView>
    );

}), isEqual);
